/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiClientsQueryResponse,
  GetApiClientsQueryParams,
} from '../models/GetApiClients.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiClientsQueryResponseSchema } from '../zod/getApiClientsSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiClientsQueryKey = (params: GetApiClientsQueryParams) =>
  [{ url: '/api/clients' }, ...(params ? [params] : [])] as const;

export type GetApiClientsQueryKey = ReturnType<typeof getApiClientsQueryKey>;

/**
 * {@link /api/clients}
 */
export async function getApiClients(
  params: GetApiClientsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiClientsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/clients`, params, ...requestConfig });
  return getApiClientsQueryResponseSchema.parse(res.data);
}

export function getApiClientsQueryOptions(
  params: GetApiClientsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiClientsQueryKey(params);
  return queryOptions<
    GetApiClientsQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiClientsQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiClients(params, config);
    },
  });
}

/**
 * {@link /api/clients}
 */
export function useGetApiClients<
  TData = GetApiClientsQueryResponse,
  TQueryData = GetApiClientsQueryResponse,
  TQueryKey extends QueryKey = GetApiClientsQueryKey,
>(
  params: GetApiClientsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiClientsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiClientsQueryKey(params);

  const query = useQuery(
    {
      ...getApiClientsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
